import http from '../api/http';
import {
  API_ETIQUETAS_GERADAS,
  API_ETIQUETAS_GERAR,
  API_ETIQUETAS_TAMANHOS,
  API_ETIQUETAS_DOWNLOAD,
  API_ETIQUETAS_PREVIEW,
} from '../api/apiConfig';
import {
  EtiquetaGerada,
  GerarEtiquetaRequest,
  ValidarBarcodeRequest,
  ValidarBarcodeResponse,
} from '../types/etiquetas';
import { createCrudService } from './crudFactory';

export const etiquetasGeradasService = createCrudService<EtiquetaGerada>(API_ETIQUETAS_GERADAS);

export const etiquetasService = {
  ...etiquetasGeradasService,

  gerar: async (data: GerarEtiquetaRequest): Promise<EtiquetaGerada> => {
    const response = await http.post(API_ETIQUETAS_GERAR, data);
    return response.data;
  },

  getTamanhos: async (): Promise<string[]> => {
    const response = await http.get(API_ETIQUETAS_TAMANHOS);
    return response.data?.tamanhos ?? response.data ?? [];
  },

  download: async (id: number | string): Promise<Blob> => {
    const response = await http.get(API_ETIQUETAS_DOWNLOAD(id), {
      responseType: 'blob',
    });
    return response.data;
  },

  preview: async (id: number | string): Promise<Blob> => {
    const response = await http.get(API_ETIQUETAS_PREVIEW(id), {
      responseType: 'blob',
    });
    return response.data;
  },

  validarBarcode: async (data: ValidarBarcodeRequest): Promise<ValidarBarcodeResponse> => {
    const response = await http.post(`${API_ETIQUETAS_GERADAS}validar-barcode/`, data);
    return response.data;
  },

  downloadEtiqueta: (id: number | string) => {
    window.open(API_ETIQUETAS_DOWNLOAD(id), '_blank');
  },

  previewEtiqueta: (id: number | string) => {
    window.open(API_ETIQUETAS_PREVIEW(id), '_blank');
  },
};
